import React, { useEffect, useRef, useState } from "react";
import { useAuthContext } from "../Contexts/AuthContext";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
import axios from "axios";
import img1 from "../assets/digitel.png";
import img2 from "../assets/MOVILNET.png";
import img3 from "../assets/movistar.png";
import img4 from "../assets/simpletv.png";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import loader from "../assets/loading.gif";

const Calculator3 = ({ }) => {
    const navigate = useNavigate();
    const [index, setIndex] = useState(0);
    const [numero, setNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(true);
    const [total, settotal] = useState("");
    const [amount, setAmount] = useState("");
    const [operator, setOperator] = useState("Digitel");
    const exchangerate = useRef();
    const { userdata, user } = useAuthContext();
    const [terms1, setTerms1] = useState(false);
    const [terms2, setTerms2] = useState(false);
    const [amountsArr, setamountsArr] = useState([]);

    const [rate, setRate] = useState(null);

    const parseEsNumber = (s = "") => {
        // "1.234,56" -> 1234.56
        const clean = String(s).trim().replace(/\./g, "").replace(",", ".");
        const n = Number(clean);
        return Number.isFinite(n) ? n : null;
    };

    useEffect(() => {
        const Fetchrate = async () => {
            const { data } = await axios.get(
                process.env.REACT_APP_BASE_URL + "/api/rates/getrates"
            );

            const rateStr = data.data[0].EXCHRATE; // whatever format you get
            const n = parseEsNumber(rateStr);

            setRate(n);
            exchangerate.current.innerHTML = rateStr; // optional: only for display
        };
        Fetchrate();
    }, []);

    useEffect(() => {
        const fetchAmounts = async () => {
            try {
                setLoading2(true);
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/recargas`);
                const data = response.data;

                if (data && data.rates && data.rates.length > 0) {
                    setamountsArr(data.rates[0].amounts);
                    setLoading2(false);
                } else {
                    console.error('No rates data found');
                    setLoading2(false);
                }
            } catch (error) {
                setLoading2(false);
                console.error('Error fetching rates:', error);
            }
        };

        fetchAmounts();
    }, []);

    const handleSubmit = async () => {
        if (Object.values(userdata).length > 2) {
            if ((operator === "SimpleTV" && numero.length === 12) || (operator !== "SimpleTV" && numero.length === 11)) {
                if (total.length > 0 && amount.length > 0) {
                    if (userdata.kyc === true) {
                        try {
                            setLoading(true);
                            await axios.post(process.env.REACT_APP_BASE_URL + "/api/orders/recharge",
                                {
                                    phone: numero,
                                    operator: (operator),
                                    total: total,
                                    amount: amount,
                                    email: userdata.email,
                                    userId: userdata.uid
                                },
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                        token: Cookies.get("token"),
                                    },
                                });

                            setNumber("");
                            settotal("");
                            setAmount("");
                            setLoading(false);
                            toast.success("Orden Recibida", {
                                position: "top-center",
                                theme: "dark"
                            });
                            setTerms2(false);
                        } catch (error) {
                            console.log(error);
                        }
                    } else {
                        toast.error("¡USUARIO PENDIENTE DE VERIFICACIÓN DE IDENTIDAD!", {
                            position: "top-center",
                            theme: "dark"
                        });
                    }

                } else {
                    toast.error("Completar todos los datos!", {
                        position: "top-center",
                        theme: "dark"
                    });
                }
            } else {
                toast.error(
                    operator !== "SimpleTV" ? "Número Telefónico DEBE TENER 11 DÍGITOS!" : "TARJETA DE ACCSO DEBE TENER 12 DÍGITOS!", {
                    position: "top-center",
                    theme: "dark"
                });
            }
        } else {
            navigate("/login");
        }
    };

    if (loading2) return <img src={loader} alt="loading..." className="loader" />;

    const amountDisabled = user ? !userdata.kyc : false;

    return (
        <div className="wv-calc">
            <style>{`
                .wv-calc {
                    /* --- brand accent (Walletven red). Change here if the exact hex differs --- */
                    --accent: #F6394F;
                    --accent-strong: #e22440;
                    --accent-tint: #fff1f3;
                    --ink: #101828;
                    --muted: #667085;
                    --label: #475467;
                    --field: #f5f6f8;
                    --field-border: #ececf0;
                    --card-border: #ececec;

                    width: 100%;
                    max-width: 560px;
                    margin: 24px auto;
                    background: #ffffff;
                    border: 1px solid var(--card-border);
                    border-radius: 20px;
                    padding: 28px;
                    box-shadow: 0 12px 44px rgba(16, 24, 40, 0.06);
                    color: var(--ink);
                    box-sizing: border-box;
                }
                .wv-calc * { box-sizing: border-box; }

                .wv-calc .wv-section { margin-top: 22px; }
                .wv-calc .wv-section:first-of-type { margin-top: 0; }

                .wv-calc .wv-label {
                    display: block;
                    font-weight: 600;
                    font-size: 0.92rem;
                    color: var(--label);
                    margin-bottom: 10px;
                }

                /* operator tiles */
                .wv-calc .wv-ops {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 12px;
                }
                .wv-calc .wv-op {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 16px 12px;
                    background: #ffffff;
                    border: 1.5px solid var(--field-border);
                    border-radius: 14px;
                    cursor: pointer;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
                }
                .wv-calc .wv-op:hover { border-color: #d7dbe0; }
                .wv-calc .wv-op img { max-width: 100%; height: auto; max-height: 32px; object-fit: contain; }
                .wv-calc .wv-op.sel {
                    border-color: var(--accent);
                    background: var(--accent-tint);
                    box-shadow: 0 0 0 3px rgba(246, 57, 79, 0.12);
                }

                /* inputs */
                .wv-calc .wv-input {
                    width: 100%;
                    background: var(--field);
                    border: 1px solid var(--field-border);
                    border-radius: 11px;
                    padding: 14px 16px;
                    font-size: 1rem;
                    color: var(--ink);
                    outline: none;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
                }
                .wv-calc .wv-input::placeholder { color: #98a2b3; }
                .wv-calc .wv-input:focus {
                    background: #ffffff;
                    border-color: var(--accent);
                    box-shadow: 0 0 0 3px rgba(246, 57, 79, 0.14);
                }
                .wv-calc .wv-input:disabled { opacity: 0.6; cursor: not-allowed; }

                /* amount chips */
                .wv-calc .wv-amounts {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(118px, 1fr));
                    gap: 10px;
                }
                .wv-calc .wv-amount {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    padding: 12px 8px;
                    border: 1.5px solid var(--field-border);
                    border-radius: 11px;
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: var(--ink);
                    background: #ffffff;
                    cursor: pointer;
                    user-select: none;
                    transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
                }
                .wv-calc .wv-amount:hover { border-color: #d7dbe0; }
                .wv-calc .wv-amount input {
                    position: absolute;
                    opacity: 0;
                    pointer-events: none;
                    width: 0;
                    height: 0;
                }
                .wv-calc .wv-amount.sel {
                    border-color: var(--accent);
                    background: var(--accent-tint);
                    color: var(--accent);
                    box-shadow: 0 0 0 3px rgba(246, 57, 79, 0.12);
                }
                .wv-calc .wv-amount.dis { opacity: 0.55; cursor: not-allowed; }

                /* summary */
                .wv-calc .wv-summary {
                    margin-top: 20px;
                    background: var(--field);
                    border-radius: 12px;
                    padding: 14px 16px;
                }
                .wv-calc .wv-summary .wv-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 0.9rem;
                    color: var(--muted);
                }
                .wv-calc .wv-summary .wv-row + .wv-row { margin-top: 8px; }
                .wv-calc .wv-summary .wv-row b { color: var(--ink); font-weight: 700; }

                /* total with badge */
                .wv-calc .wv-total-wrap { position: relative; }
                .wv-calc .wv-total-wrap .wv-input {
                    padding-right: 64px;
                    font-weight: 700;
                    background: #ffffff;
                }
                .wv-calc .wv-badge {
                    position: absolute;
                    right: 8px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: var(--ink);
                    color: #ffffff;
                    font-size: 0.72rem;
                    font-weight: 700;
                    letter-spacing: 0.03em;
                    padding: 6px 10px;
                    border-radius: 8px;
                }

                .wv-calc .wv-note { margin: 10px 0 0; font-size: 0.78rem; color: #98a2b3; }

                .wv-calc .wv-submit {
                    width: 100%;
                    margin-top: 20px;
                    padding: 16px;
                    background: var(--accent);
                    color: #ffffff;
                    font-weight: 700;
                    font-size: 1rem;
                    border: none;
                    border-radius: 11px;
                    cursor: pointer;
                    transition: background 0.15s ease, transform 0.05s ease;
                }
                .wv-calc .wv-submit:hover:not(:disabled) { background: var(--accent-strong); }
                .wv-calc .wv-submit:active:not(:disabled) { transform: translateY(1px); }
                .wv-calc .wv-submit:disabled { opacity: 0.6; cursor: not-allowed; }

                /* modals */
                .wv-calc-modal-backdrop { position: fixed; inset: 0; background: rgba(16, 24, 40, 0.45); z-index: 200000; }
                .wv-calc-modal { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center; padding: 20px; z-index: 200001; }
                .wv-calc-modal-card { width: 100%; max-width: 460px; background: #ffffff; border-radius: 16px; box-shadow: 0 24px 60px rgba(16, 24, 40, 0.25); overflow: hidden; }
                .wv-calc-modal-head { display: flex; align-items: center; justify-content: space-between; padding: 20px 24px; border-bottom: 1px solid #f0f1f4; }
                .wv-calc-modal-head h2 { margin: 0; font-size: 1.1rem; font-weight: 700; color: #101828; }
                .wv-calc-modal-close { background: none; border: none; font-size: 1.4rem; line-height: 1; color: #98a2b3; cursor: pointer; padding: 4px; }
                .wv-calc-modal-close:hover { color: #101828; }
                .wv-calc-modal-body { padding: 22px 24px; color: #475467; font-size: 0.95rem; line-height: 1.6; }
                .wv-calc-modal-body b { color: #101828; }
                .wv-calc-modal-foot { display: flex; justify-content: flex-end; gap: 12px; padding: 16px 24px; border-top: 1px solid #f0f1f4; }
                .wv-calc-modal-btn { padding: 11px 22px; font-weight: 600; border-radius: 9px; cursor: pointer; border: none; font-size: 0.92rem; }
                .wv-calc-modal-btn.primary { background: var(--accent, #F6394F); color: #ffffff; }
                .wv-calc-modal-btn.primary:hover:not(:disabled) { background: #e22440; }
                .wv-calc-modal-btn.primary:disabled { opacity: 0.6; cursor: not-allowed; }
                .wv-calc-modal-btn.ghost { background: #f0f1f4; color: #475467; }
                .wv-calc-modal-btn.ghost:hover { background: #e6e8ec; }

                @media (max-width: 480px) {
                    .wv-calc { padding: 20px; border-radius: 16px; }
                }
            `}</style>

            <div className="wv-section">
                <label className="wv-label">Selecciona Operador</label>
                <div className="wv-ops">
                    <div
                        className={`wv-op ${operator === "Digitel" ? "sel" : ""}`}
                        onClick={() => {
                            setIndex(0); setOperator("Digitel");
                            settotal((Number(amountsArr[0][0] /
                                rate) + 2.5).toLocaleString("es-ES", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }));
                        }}
                    >
                        <img src={img1} alt="Digitel logo" />
                    </div>
                    <div
                        className={`wv-op ${operator === "Movilnet" ? "sel" : ""}`}
                        onClick={() => {
                            setIndex(1); setOperator("Movilnet");
                            settotal((Number(amountsArr[1][0] /
                                rate) + 2.5).toLocaleString("es-ES", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }));
                        }}
                    >
                        <img src={img2} alt="Movilnet logo" />
                    </div>
                    <div
                        className={`wv-op ${operator === "Movistar" ? "sel" : ""}`}
                        onClick={() => {
                            setIndex(2); setOperator("Movistar");
                            settotal((Number(amountsArr[2][0] /
                                rate) + 2.5).toLocaleString("es-ES", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }));
                        }}
                    >
                        <img src={img3} alt="Movistar logo" />
                    </div>
                </div>
            </div>

            <div className="wv-section">
                <label className="wv-label">
                    {operator === "SimpleTV" ? "Tarjeta de Acceso" : "Número Telefónico"}
                </label>
                <input
                    type="text"
                    className="wv-input"
                    id="number"
                    inputMode="numeric"
                    placeholder={operator === "SimpleTV" ? "" : "Ej. 0412XXXXXXX"}
                    value={numero}
                    onChange={(e) => {
                        if ((operator === "SimpleTV" && e.target.value.length <= 12) ||
                            (operator !== "SimpleTV" && e.target.value.length <= 11)) setNumber(e.target.value);
                    }}
                    disabled={user ? !userdata.kyc : false}
                />
            </div>

            <div className="wv-section">
                <label className="wv-label">Selecciona Monto</label>
                <div className="wv-amounts">
                    {amountsArr[index].map((elem, i) => {
                        const sel = String(amount) === String(amountsArr[index][i]);
                        return (
                            <label key={i} className={`wv-amount ${sel ? "sel" : ""} ${amountDisabled ? "dis" : ""}`}>
                                <input
                                    type="radio"
                                    name="amount"
                                    checked={sel}
                                    onChange={() => {
                                        settotal((Number(amountsArr[index][i] /
                                            rate) + 2.5).toLocaleString("es-ES", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            }));
                                        setAmount(amountsArr[index][i]);
                                    }}
                                    disabled={amountDisabled}
                                />
                                <span>{elem} VES</span>
                            </label>
                        );
                    })}
                </div>
            </div>

            <div className="wv-summary">
                <div className="wv-row">
                    <span>Comisión</span>
                    <b id="totalFees">2,50 €</b>
                </div>
                <div className="wv-row">
                    <span>Tasa</span>
                    <b>1 EUR = <span id="exchangerate" ref={exchangerate}></span> €</b>
                </div>
            </div>

            <div className="wv-section">
                <label className="wv-label">Total a pagar</label>
                <div className="wv-total-wrap">
                    <input
                        type="text"
                        className="wv-input"
                        id="total"
                        value={total}
                        readOnly
                    />
                    <span className="wv-badge">EUR</span>
                </div>
                <p className="wv-note">*Resultado sujeto a tasas y tipos de cambio variables.</p>
            </div>

            <button
                className="wv-submit"
                disabled={loading || (user ? !userdata.kyc : false)}
                onClick={() => {
                    if (Object.values(userdata).length > 2) {
                        if ((operator === "SimpleTV" && numero.length === 12) || (operator !== "SimpleTV" && numero.length === 11)) {
                            if (total.length > 0) {
                                if (userdata.kyc === true) {
                                    setTerms1(true);
                                } else {
                                    toast.error("¡USUARIO PENDIENTE DE VERIFICACIÓN DE IDENTIDAD!", {
                                        position: "top-center",
                                        theme: "dark"
                                    });
                                }
                            } else {
                                toast.error("Completar todos los datos!", {
                                    position: "top-center",
                                    theme: "dark"
                                });
                            }
                        } else {
                            toast.error(
                                operator !== "SimpleTV" ? "Número Telefónico DEBE TENER 11 DÍGITOS!" : "TARJETA DE ACCSO DEBE TENER 12 DÍGITOS!", {
                                position: "top-center",
                                theme: "dark"
                            });
                        }
                    } else {
                        navigate("/login");
                    }
                }}>
                {loading ? "Enviando" : "Continuar"}
            </button>

            {terms1 && (
                <>
                    <div className="wv-calc-modal-backdrop" onClick={() => setTerms1(false)}></div>
                    <div className="wv-calc-modal">
                        <div className="wv-calc-modal-card">
                            <div className="wv-calc-modal-head">
                                <h2>Términos y Condiciones</h2>
                                <button
                                    type="button"
                                    className="wv-calc-modal-close"
                                    aria-label="Cerrar"
                                    onClick={() => setTerms1(false)}
                                >
                                    &times;
                                </button>
                            </div>
                            <div className="wv-calc-modal-body">
                                <b>RECORDATORIO:</b> Los pagos deben realizarse desde una cuenta bancaria o tarjeta particular <b>A TU NOMBRE.</b> Los pagos realizados con terceros no serán aceptados, gastos por gestión serán aplicados y se devolverán a origen en un plazo de 15 días hábiles.
                            </div>
                            <div className="wv-calc-modal-foot">
                                <button
                                    type="button"
                                    className="wv-calc-modal-btn ghost"
                                    onClick={() => setTerms1(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="wv-calc-modal-btn primary"
                                    onClick={() => {
                                        setTerms2(true);
                                        setTerms1(false);
                                    }}
                                >
                                    Entiendo
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {terms2 && (
                <>
                    <div className="wv-calc-modal-backdrop" onClick={() => setTerms2(false)}></div>
                    <div className="wv-calc-modal">
                        <div className="wv-calc-modal-card">
                            <div className="wv-calc-modal-head">
                                <h2>Términos y Condiciones</h2>
                                <button
                                    type="button"
                                    className="wv-calc-modal-close"
                                    aria-label="Cerrar"
                                    onClick={() => setTerms2(false)}
                                >
                                    &times;
                                </button>
                            </div>
                            <div className="wv-calc-modal-body">
                                <b>INSTRUCCIONES:</b> Recibirá en su email los datos bancarios para el pago de su Orden de Recarga Telefónica y el concepto/observaciones/notas que debe colocar. Pagos sin concepto u otras referencias generarán un atraso en el proceso de verificación de su pago y gastos por gestión.
                            </div>
                            <div className="wv-calc-modal-foot">
                                <button
                                    type="button"
                                    className="wv-calc-modal-btn ghost"
                                    onClick={() => setTerms2(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="wv-calc-modal-btn primary"
                                    onClick={() => handleSubmit()}
                                    disabled={loading}
                                >
                                    {loading ? "Enviando" : "Entiendo"}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default (Calculator3);